import {
  NeedDto,
  NeedUpdateDto,
  NeedsActionDto,
  NeedsHistoryEntryDto,
  NeedsResourceDetailsDto,
} from '@act/shared/data-transfer-objects';
import { needsSelectors } from 'redux/slices/needs.slice';
import NeedUpdateHistoryEntry from './HistoryEntries/NeedUpdateHistoryEntry';
import NeedResourceDetailsHistoryEntry from './HistoryEntries/NeedResourceDetailsHistoryEntry';
import { NeedCallHistoryEntry } from './HistoryEntries/NeedCallHistoryEntry';
import { NeedVisitHistoryEntry } from './HistoryEntries/NeedVisitHistoryEntry';
import { NeedActionHistoryEntry } from './HistoryEntries/NeedActionHistoryEntry';

interface NeedDetailHistoryEntryProps {
  need: NeedDto;
  historyEntry: NeedsHistoryEntryDto;
  detailMode?: boolean;
  editMode?: boolean;
  setEdit?: (action: NeedsActionDto) => void;
  setEditNeed?: (need: NeedDto) => void;
}

const NeedDetailHistoryEntry = ({
  need,
  historyEntry,
  detailMode,
  editMode,
  setEditNeed,
  setEdit,
}: NeedDetailHistoryEntryProps) => {
  const action: NeedsActionDto = needsSelectors.useSelectActionById(
    historyEntry.actionId
  );
  const needUpdate: NeedUpdateDto = needsSelectors.useSelectNeedUpdateById(
    historyEntry.needUpdateId
  );
  const resourceDetails: NeedsResourceDetailsDto =
    needsSelectors.useSelectResourceDetailsById(historyEntry.resourceDetailsId);

  if (historyEntry.actionId) {
    return (
      <NeedActionHistoryEntry
        action={action}
        detailMode={detailMode}
        editMode={editMode}
        setEdit={setEdit}
      />
    );
  } else if (historyEntry.needUpdateId) {
    return (
      <NeedUpdateHistoryEntry
        need={need}
        needUpdate={needUpdate}
        detailMode={detailMode}
        editMode={editMode}
        setEditNeed={setEditNeed}
      />
    );
  } else if (historyEntry.resourceDetailsId) {
    return (
      <NeedResourceDetailsHistoryEntry resourceDetails={resourceDetails} />
    );
  } else if (historyEntry.callId) {
    return <NeedCallHistoryEntry historyEntry={historyEntry} />;
  } else if (historyEntry.visitId) {
    return <NeedVisitHistoryEntry historyEntry={historyEntry} />;
  }
  return (
    <div>
      Entry with actionId: {historyEntry.actionId} and needUpdateId:{' '}
      {historyEntry.needUpdateId} and resourceDetailsId:{' '}
      {historyEntry.resourceDetailsId}
    </div>
  );
};

export default NeedDetailHistoryEntry;
